import RUF from "../../../util/redux";

export function downPaymentClosingCostsSave(state, action) {
  return RUF.updateObject(state, {
    model: RUF.updateObject(state.model, {
      downPayment: RUF.updateObject(state.model.downPayment, {
        closingCosts: action.payload
      })
    })
  });
}
